import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../../../utils/api';
import { YButton } from '../../../ui/YButton';

export function ClubFeedersSummaryPanel({ clubId }) {
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!clubId) return undefined;
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const resp = await api.get(`/clubs/${clubId}/feeding-summary/`);
        if (!cancelled) setSummary(resp.data || null);
      } catch (e) {
        if (!cancelled) {
          setSummary(null);
          setError('Unable to load feeder status.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [clubId]);

  if (loading) {
    return (
      <div className="club-detail-feeders-block" data-testid="club-feeders-summary-loading">
        <Spinner animation="border" size="sm" />
      </div>
    );
  }

  if (error || !summary) {
    return null;
  }

  const lowFeeders = summary.low_feeders || [];
  if (lowFeeders.length === 0) {
    return null;
  }

  return (
    <div className="club-detail-feeders-block" data-testid="club-feeders-summary">
      <div className="d-flex align-items-start justify-content-between gap-3 mb-2">
        <div>
          <div className="club-detail-section__subhead mb-0">Feeders</div>
          <p className="club-detail-feeders-block__lead mb-0">
            {summary.attention_count} feeder{summary.attention_count === 1 ? '' : 's'} need attention
          </p>
        </div>
        <YButton variant="secondary" size="sm" onClick={() => navigate('/toolkit/feed-management')}>
          Feed manager
        </YButton>
      </div>
      <ul className="club-feeders-summary-list mb-0">
        {lowFeeders.map((feeder) => (
          <li key={feeder.id} className="club-feeders-summary-list__item">
            <div className="club-feeders-summary-list__main">
              <span className="club-feeders-summary-list__name">{feeder.name}</span>
              <span className="club-feeders-summary-list__meta">
                {feeder.percent_remaining != null ? `${feeder.percent_remaining}% remaining` : 'Low'}
                {feeder.owner_display_name ? ` · ${feeder.owner_display_name}` : ''}
              </span>
            </div>
            <span className={`club-feeders-summary-list__pct${feeder.percent_remaining != null && feeder.percent_remaining <= 0 ? ' club-feeders-summary-list__pct--critical' : ''}`}>
              {feeder.percent_remaining != null ? `${feeder.percent_remaining}%` : '—'}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

ClubFeedersSummaryPanel.propTypes = {
  clubId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ClubFeedersSummaryPanel;
